module.exports = __webpack_public_path__ + "img/img8.67643212.png";